// pl_pms_manager_dashboard.ts
// Tłumaczenia dla ekranu Manager Dashboard (ManagerDashboard.tsx)
// Statusy pokoi, akcje, common labels → importuj z pl_pms_common.ts

export const plPmsManagerDashboard = {

  // ── Tytuły modali szczegółów ──────────────────────────────────────────────
  detailTitles: {
    rooms:    { title: "Pokoje i stan inwentarza",        sub: "Status pokoi na żywo na wszystkich piętrach" },
    guest:    { title: "Doświadczenie gości",              sub: "Satysfakcja, opinie i odzyskiwanie usług (ostatnie 90 dni)" },
    dept:     { title: "Przegląd działów",                 sub: "Status, obciążenie i wyjątki wg działów (dziś)" },
    segments: { title: "Najsilniejsze segmenty popytu",   sub: "Pokojonoce i przychód wg segmentu (ostatnie 28 dni)" },
    market:   { title: "Rynek i tempo",                    sub: "Benchmark względem zestawu konkurencji" },
    labor:    { title: "Przegląd zatrudnienia",            sub: "Obsada i koszty w działach (dziś)" },
    risk:     { title: "Kolejka ryzyk operacyjnych",       sub: "Aktywne ryzyka wymagające uwagi" },
  },

  // ── Pasek KPI ─────────────────────────────────────────────────────────────
  kpi: {
    occupancy:        "Obłożenie",
    adr:              "ADR",
    revpar:           "RevPAR",
    revenueToday:     "Przychód dziś",
    forecastPickup:   "Pickup prognozy",
    guestSatisfaction:"Satysfakcja gości",
    openIssues:       "Otwarte problemy",
    laborCoverage:    "Pokrycie kadrowe",
    onTheBooks:       "Na księdze",
    onTarget:         "Na celu",
    belowPlan:        "Poniżej planu",
    vsLY:             "vs UB",       // vs Ubiegły Rok
    vsFCST:           "vs PROG",     // vs Prognoza
  },

  // ── Sekcja wykres / Performance & Forecast ────────────────────────────────
  performanceForecast: {
    title:           "Wynik i prognoza",
    legendRevenue:   "Przychód ($)",
    legendOccupancy: "Obłożenie (%)",
    revenueToday:    "Przychód dziś",
    revenueForecast: "Prognoza przychodu",
    next7Days:       "kolejne 7 dni",
  },

  // ── Pokoje i inwentarz ────────────────────────────────────────────────────
  rooms: {
    title:                  "Pokoje i stan inwentarza",
    viewDetails:            "Zobacz szczegóły",
    sellableInventory:      "Inwentarz sprzedawalny",
    housekeepingReadiness:  "Gotowość housekeepingu",
    outOfOrder:             "Wyłączone z użytku",
    blockedRooms:           "Pokoje zablokowane",
    maintenanceImpact:      "Wpływ techniczny",
    blockedForRevenue:      "Zablokowane dla przychodu",
    noImpact:               "Brak wpływu",
    arrivalRoomsNotReady:   "Pokoje przyjazdowe niegotowe",
    highPriority:           "Wysoki priorytet",
    allClear:               "Wszystko gotowe",
    // Szczegóły modalu
    totalRooms:             "Wszystkie pokoje",
    sellable:               "Sprzedawalne",
    occupied:               "Zajęte",
    available:              "Dostępne",
    dirtyBlocked:           "Brudne / Zablokowane",
    byFloor:                "Według piętra",
    tableHeaders:           ["Piętro", "Razem", "Zajęte", "Dostępne", "Brudne", "Zarezerwowane", "Wył."],
    floorLabel:             "Piętro",
    reservedForArrivals:    "zarezerwowanych na nadchodzące przyjazdy",
    room:                   "pokój",
    rooms:                  "pokoi",
    ofTotal:                "% całości",
    ofOccupancy:            "% obłożenia",
  },

  // ── Doświadczenie gości ───────────────────────────────────────────────────
  guest: {
    title:             "Puls doświadczenia gości",
    viewDetails:       "Zobacz szczegóły",
    satisfactionScore: "Wynik satysfakcji",
    activeComplaints:  "Aktywne skargi",
    vipArrivalsToday:  "Przyjazdy VIP dziś",
    vipInHouse:        "in-house",
    highPriority:      "Wysoki priorytet",
    noneOpen:          "Brak otwartych",
    serviceRecovery:   "Service recovery",
    openCases:         "Otwarte sprawy",
    reviewSentiment:   "Sentyment opinii",
    noReviewsYet:      "Brak opinii",
    responseSLA:       "SLA odpowiedzi",
    onTarget:          "Na celu",
    belowTarget:       "Poniżej celu",
    noData:            "Brak danych",
    noGuestData:       "Brak danych o doświadczeniu gości.",
    positiveReviews:   "% pozytywnych",
    reviews:           "opinii",
    // Szczegóły modalu – tabela
    detailLabels: {
      satisfaction:    "Satysfakcja",
      reviews90d:      "Opinie (90d)",
      responseSLA:     "SLA odpowiedzi",
      complaints:      "Aktywne skargi",
      serviceRecovery: "Service recovery",
      openCasesLabel:  "otwarte sprawy",
      vipTodayInHouse: "VIP dziś / in-house",
    },
    sentiment: {
      label:    "Sentyment opinii",
      positive: "Pozytywny",
      neutral:  "Neutralny",
      negative: "Negatywny",
    },
  },

  // ── Przegląd działów ─────────────────────────────────────────────────────
  dept: {
    title:        "Przegląd działów",
    viewAll:      "Zobacz wszystko",
    noData:       "Brak danych kadrowych na dziś.",
    loading:      "Ładowanie...",
    atRisk:       "Zagrożone",
    onTrack:      "Na planie",
    tableHeaders: ["Dział", "Status", "Obciążenie", "Wyjąt.", "Opiekun"],
    detailHeaders:["Dział", "Opiekun", "Status", "Obciążenie", "Plan", "Wym.", "Pokrycie", "Wyjąt."],
  },

  // ── Segmenty popytu ───────────────────────────────────────────────────────
  segments: {
    title:        "Najsilniejsze segmenty popytu",
    stayDate:     "Data pobytu",
    viewAll:      "Zobacz wszystko",
    noData:       "Brak pobytów z ostatnich 28 dni.",
    loading:      "Ładowanie...",
    other:        "Inne",
    total:        "Razem",
    tableHeaders: ["Segment", "Pokoje", "% całości", "ADR", "RevPAR"],
    detailHeaders:["Segment", "Pokojonoce", "% Udziału", "Przychód", "ADR", "RevPAR"],
  },

  // ── Rynek i tempo ─────────────────────────────────────────────────────────
  market: {
    title:            "Rynek i tempo",
    viewAll:          "Zobacz wszystko",
    noData:           "Brak danych rynkowych.",
    asOf:             "Stan na",
    marketOccupancy:  "Obłożenie rynku",
    marketADR:        "ADR rynku",
    marketRevPAR:     "RevPAR rynku",
    compSetIndex:     "Indeks comp set",
    aboveCompSet:     "Powyżej comp set",
    belowCompSet:     "Poniżej comp set",
    paceToForecast:   "Tempo do prognozy",
    revenueForecast7d:"Prognoza przychodu (7d)",
    vs28dAgo:         "vs 28 dni temu",
    onPace:           "Na tempie",
    behindPace:       "W tyle",
    noForecast:       "Brak prognozy",
    description:      "Odchylenia porównują aktualny benchmark z tym samym wskaźnikiem sprzed 28 dni. Indeks comp set powyżej 100 oznacza, że obiekt wyprzedza konkurencję.",
  },

  // ── Przegląd zatrudnienia ─────────────────────────────────────────────────
  labor: {
    title:         "Przegląd zatrudnienia",
    viewAll:       "Zobacz wszystko",
    noData:        "Brak danych kadrowych.",
    coverage:      "Pokrycie",
    scheduled:     "Zaplanowane",
    totalCost:     "Łączny koszt pracy",
    vsRequired:    "vs wymagane",
    required:      "wymagane",
    byDept:        "Według działu",
    noPerDept:     "Brak danych per dział.",
    onTarget:      "Na celu",
    belowPlan:     "Poniżej planu",
    noDataShort:   "Brak danych",
    revenueOf:     "% przychodu",
    staffingGap:   "Luka kadrowa",
    fullyCovered:  "Pełne pokrycie",
    tableHeaders:  ["Dział", "Plan", "Wymagane", "Pokrycie", "Opiekun"],
  },

  // ── Brief kierowniczy ─────────────────────────────────────────────────────
  leadershipBrief: {
    title:                   "Brief kierowniczy",
    todaySummary:            "Podsumowanie dnia",
    upcomingHighlights:      "Nadchodzące wydarzenia",
    notes:                   "Notatki",
    noActiveNotes:           "Brak aktywnych notatek. Dodaj z Live Board.",
    noUpcomingGroupBlocks:   "Brak nadchodzących blokad grupowych",
    pickupVsYesterday:       "Pickup vs wczoraj",
    revenuePace:             "Tempo przychodu",
    compSetIndex:            "Comp Set Index",
    displacement:            "Wyparcie",
    today:                   "dziś",
    groupPrefix:             "Grupa: ",
    noReleaseDate:           "Brak daty release",
    rooms:                   "pokoi",
    room:                    "pokój",
    pickupOf:                "pickup",
  },

  // ── Kolejka ryzyk ─────────────────────────────────────────────────────────
  risk: {
    title:    "Kolejka ryzyk operacyjnych",
    viewAll:  "Zobacz wszystko",
    noRisks:  "Brak aktywnych ryzyk operacyjnych",
    loading:  "Ładowanie...",
  },

} as const;

export default plPmsManagerDashboard;
